import type { ReactNode } from "react";

import { styled } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import type { ICheckboxProps } from "@similarweb/ui-components";
import { Checkbox } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

const StyledCheckbox = styled(Checkbox)`
    label {
        width: 100%;
    }
`;

type ExportItemProps = Pick<ICheckboxProps, "onClick" | "selected" | "halfSelected" | "isDisabled"> & {
    countLabel: ReactNode;
    dataAutomation?: string;
    label: ReactNode;
};

export const ExportItem = ({ countLabel, dataAutomation, label, ...checkboxProps }: ExportItemProps) => (
    <StyledCheckbox
        {...checkboxProps}
        label={
            <Flex
                alignItems="center"
                justifyContent="space-between"
                data-automation={dataAutomation}
                gap="16px"
            >
                <Text
                    fontVariant="body1"
                    color={colorsPalettes.carbon[300]}
                >
                    {label}
                </Text>
                <Text
                    fontVariant="body1"
                    color={colorsPalettes.carbon[300]}
                >
                    {countLabel}
                </Text>
            </Flex>
        }
    />
);
